import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { I18N_SERP_NS } from './constants';
export const useSerpTranslation = () => {
    const { t: translate } = useTranslation(I18N_SERP_NS);
    const t = (key, options) => {
        const optionsWithoutEscaping = { ...(options ?? {}), unsafe_escapeValue: false };
        return translate(key, optionsWithoutEscaping);
    };
    return { t };
};
